import React from 'react';
import './SecurityHero.css';

function SecurityHero() {
  return (
    <section className="security-hero-wrapper">
      <div className="security-hero-content-area">
        <h1 className="security-hero-title">Sendbird Security</h1>
        <p className="security-hero-description">
          At Sendbird, security isn't just a feature, it's in our DNA. Trust is earned, and we earn yours by keeping your data safe.
        </p>
        <a href="" role="button" className="security-hero-cta-button">
          Contact sales
        </a>
      </div>
      <div className="security-hero-image-area">
        <img 
          src="https://sendbird.imgix.net/cms/security-visual.png?auto=format,compress&crop=faces" 
          alt="Abstract security interface" 
        />
      </div>
    </section>
  );
}

export default SecurityHero;